import { apiRequest } from "../../../apiHelper/apiRequest";
import { serialize } from "../../../helpers/helpers";

const getLanguageList = async (params) => {
    return apiRequest(
        "/languages/list?" + serialize(params),
        {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        },
        'ptp_client'
    );
}


const addLanguageList = async (params) => {
    return apiRequest(
        "/languages/add",
        {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params)
        },
        'ptp_client'
    );
}

const updateLanguageList = async (params) => {
    return apiRequest(
        "/languages/update",
        {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params)
        },
        'ptp_client'
    );
}

const deleteLanguageList = async (lang_id) => {
    return apiRequest(
        `/languages/delete/${lang_id}`,
        { method: "DELETE" },
        'ptp_client'
    );
}

const getUserById = async (lang_id) => {
    return apiRequest(
        `/languages/get/${lang_id}`,
        { method: "GET" },
        'ptp_client'
    );
}

const apiLanguageMethodService = {
    getUserById,
    getLanguageList,
    addLanguageList,
    updateLanguageList,
    deleteLanguageList,
}

export default apiLanguageMethodService;